import { Footer, SectionTitle, TopBarVisitor } from '@sloyd/ui';
import Community from '../../components/Community/Community';
import Features from '../../components/Features/Features';
import Hero from '../../components/Hero/Hero';
import Personas from '../../components/Personas/Personas';
import Stats from '../../components/Stats/Stats';
import { Wrapper } from './PageLanding.style';

export type PageLandingProps = {
  callbacks: {
    onHeroCta: () => void;
  };
};

export function PageLanding(props: PageLandingProps) {
  const { callbacks } = props;

  return (
    <Wrapper className='PageLanding-wrapper' data-testid='PageLanding-wrapper'>
      <TopBarVisitor></TopBarVisitor>
      <Hero onCta={callbacks.onHeroCta} />
      <SectionTitle title='Fastest Growing 3D Community'>
        Use <strong>generator-models</strong>, models that can be endlessly randomized to create
        dozens of unique permutations.
      </SectionTitle>
      <Community />
      <Personas />
      <Stats />
      <Features />
      <Footer />
    </Wrapper>
  );
}

export default PageLanding;
